// extracted by mini-css-extract-plugin
export default {"tabContainer":"AccountBaseDrawer_tabContainer__r+dDY","tabPane":"AccountBaseDrawer_tabPane__f-5ZP"};